import React from 'react';
import CampaignCodeControlContainer from './container';
export default CampaignCodeControlContainer;

export function CampaignCodeControl({
  targetCampaignCode,
  children,
  userCampaignCodes,
  teamCampaignCodes,
  excludeUserCampaignCodes = false,
  excludeTeamCampaignCodes = false,
  fallbackComponent
}) {
  // console.log('component::: userCampaignCodes', userCampaignCodes);
  // console.log('component::: teamCampaignCodes', teamCampaignCodes);
  // console.log('component::: targetCampaignCode', targetCampaignCode);
  if (!children) {
    // console.log('Fallback component::: !children');
    return fallbackComponent || <></>;
  } else if (targetCampaignCode) {
    const _codeType = typeof targetCampaignCode;
    const _codes = [
      ...((excludeUserCampaignCodes ? [] : userCampaignCodes) || []),
      ...((excludeTeamCampaignCodes ? [] : teamCampaignCodes) || [])
    ].map(code => code.text);
    var _checker = false;
    // if targetCampaignCode is an array
    if (_codeType === 'object') {
      // console.log("component::: _codeType === 'object' : targetCampaignCode", targetCampaignCode);
      // check if every element in targetCampaignCode is in _codes
      _checker = targetCampaignCode.every(code => _codes.includes(code.toUpperCase()));
    } else if (_codeType === 'string') {
      _checker = _codes.includes(targetCampaignCode.toUpperCase());
    }
    if (_checker) {
      // console.log('component::: _checker');
      return children;
    } else {
      // console.log('Fallback component::: _checker false');
      return fallbackComponent || <></>;
    }
  } else {
    // console.log('component::: no targetCampaignCode');
    return children;
  }
}
